// Темы / платформа + backward-compat re-exports.
// Канонические `localeSchema`, `countryCodeSchema`, `timezoneSchema` живут в `./common.ts`.
import { z } from "zod";

// `ianaTimezoneSchema` — алиас канонического `timezoneSchema` (используется в users/onboarding/push-tokens).
export {
	COUNTRY_CODES,
	type CountryCode,
	countryCodeSchema,
	EDUCATION_COUNTRY_CODES,
	type EducationCountryCode,
	educationCountryCodeSchema,
	GENERATION_LOCALE_SOURCE,
	generationLocalePrefSchema,
	localeSchema,
	timezoneSchema as ianaTimezoneSchema,
} from "./common.js";

/** UI-тема приложения. */
export const themeSchema = z.enum(["system", "light", "dark"]);
export type Theme = z.infer<typeof themeSchema>;

/** Платформа клиента (web / native). */
export const platformSchema = z.enum(["web", "android", "ios", "admin"]);
export type Platform = z.infer<typeof platformSchema>;
